import React, {Component} from 'react'
import fig1 from '../Assets/rezum/fig_1.png'
import fig2 from '../Assets/rezum/fig_2.png'
import fig3 from '../Assets/rezum/fig_3.png'
import fig4 from '../Assets/rezum/fig_4.png'
import fig5 from '../Assets/rezum/fig_5.png'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import CardMedia from "@material-ui/core/CardMedia"
import styles from '../App.css';


const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '75%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/rezum-video-1.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 100 }} 
      />
    </div>
  );
};

 
const Rezum = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)
    switch (language) {
        case 'EN':
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>Rezum™ method ( Water Vapour Therapy)</h2>
                            <hr/>
                            <p className="white">
                                Benign prostatic hyperplasia (BPH) is an enlargement of the prostate gland affecting
                                about 50% of men by age 60, and up to 90% of men by age 85.1 This enlargement can
                                compress the urethra, reducing the flow of urine from the bladder, and sometimes
                                blocking it entirely.
                                <hr/>
                                <h2>The symptoms of BPH include:</h2><br/>
                                - Urinary frequency<br/>
                                - Irregular flow<br/>
                                - Urgency<br/>
                                - Weak stream<br/>
                                - Getting up at night to urinate <br/>
                                - Straining
                                <hr/>
                                <h2>Treating BPH</h2><br/>
                                Not ready for surgery, but don’t want to be on medication? Rezum™ Water Vapor Therapy is
                                an option designed to reduce BPH symptoms in men with enlarged prostates — without the
                                side effects of BPH medications.
                                <hr/>
                                <h2>See the difference</h2><br/>
                                Rezum™ Water Vapor Therapy uses the natural energy stored in water vapor, or steam.
                                Clinical studies show a positive safety profile with the ability to relieve symptoms
                                associated with BPH.
                                During each 9-second treatment, sterile water vapor is released throughout the targeted
                                prostate tissue. When the steam turns back into water, all the stored energy is
                                released, causing the cells to die.
                                Over time, your body’s natural healing response removes the dead cells, shrinking the
                                prostate. With the extra tissue removed, the urethra opens, reducing BPH symptoms.
                                Most patients begin to experience symptom relief in as soon as two weeks, and maximum
                                benefit may occur within three months. Patient responses can and do vary.
                                <hr/>
                                <h2>Procedure</h2><br/>
                                The number of water vapor treatments varies depending on the size of the prostate. The
                                procedure is done during one appointment. The images above are intended to show how the
                                procedure works, not to provide an exact representation of patient results.
                                <hr/>
                                <h2>3 Simple Steps</h2><br/>
                                1.Before your procedure<br/>
                                - Your doctor may stop anticoagulants (blood thinners) a few days to a week prior to
                                your procedure.<br/>
                                - Antibiotics may be prescribed.<br/>
                                - Your doctor will discuss any pain medications that will be used.<br/>
                                2. Procedure day<br/>
                                - The actual procedure takes only minutes; however, plan on spending approximately two
                                hours for the entire appointment.<br/>
                                - You will receive pain medication prescribed by your doctor for the procedure.<br/>
                                - Plan to have a driver for your appointment, unless your doctor tells you that you can
                                drive yourself home.<br/>
                                3. Resume your life
                                - After your procedure, continue oral antibiotics as prescribed by your doctor.<br/>
                                - Your doctor may recommend a catheter for a few days to ease urination during
                                healing<br/>
                                - Avoid activities that may irritate your prostate. Consult your doctor for specific
                                recommendations.<br/>
                                - If you experience discomfort:<br/>
                                <ol>
                                    <li>Take a mild pain medication, as recommended by your doctor.</li>
                                    <li>Try a warm bath or sitting on a hot water bottle</li>
                                    <li>Consider temporarily removing caffeine, chocolate and alcohol from your diet.
                                    </li>
                                </ol>
                                <hr/>
                                Within a few days, you will most likely be able to resume normal activities* and most
                                patients will experience noticeable symptom improvement in as soon as two weeks.

                                  <MyReactPlayer/><br/>    
                                    
                            </p>
                        </div>
                    </div>
                </section>
            )
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>Резум (Rezūm): вълнуваща нова минимално инвазивнa технология предлага щадящо лечение при
                                пациенти, страдащи от уголемена простата </h2>
                            <hr/>
                            <p className="white">
                                <h2>Трансуретрална аблация на простатата с водна пара по метода Rezūm</h2>
                                B Манхайм, Германия под ръководството на Д-р Георги Тосев от февруари 2020 г. се
                                използва нов щадящ метод за намаляване на простатата при доброкачествена простатна
                                хиперплазия с водна пара (Rezūm ™ Firma Boston Scientific).
                                Като орган на половата система, простатната жлеза претърпява възрастови промени. С
                                напредването на възрастта простатната жлеза хипертрофира (уголемява се), като с
                                уголемяването на средния и централния си дял притиска пикочния канал и причинява
                                затруднение в уринирането (погледни фигура 1).<br/>
                                <CardMedia
                                    component='img'
                                    image={fig1}
                                />
                                <h2>Възникване и развитие на доброкачествената простатна хиперплазия </h2>
                                Доброкачествената простатна хиперплазия се предизвиква от различни хормонални промени с
                                напредване на възрастта. Точната причина не е напьлно изяснена. Тестостеронът, който се
                                образува от тестисите, се преобразува в по-активния метаболит дихидротестостерон и една
                                малка част – в естрадиол. Установено е, че високите нива на дихидротестостерон в
                                простатата са свързани с увеличението на обема на жлезата. Следните рискови фактори
                                допринасят за развитието простатна хиперплазия: възрастта, фамилната обремененост,
                                повишените нива на хормоните дихидротестостерон и естрадиол, наднорменото тегло,
                                диабетът, високите нива на холестерола, високото кръвно налягане, мeтаболитният синдром,
                                атеросклерозата, начинът на живот, консумацията на алкохол и отслабената имунна система.
                                <h2>Симптоми при доброкачествената простатна хиперплазия:</h2>
                                Доброкачествената простатна хиперплазия (ДПХ) e увеличаване на простатната жлеза, което
                                засяга около 50% от мъжете до 60-годишна възраст и приблизително 90% от мъжете до 80
                                години. В резултат на нарастването и притискането простатната част на уретрата
                                претърпява значителни изменения. Пикочният канал в областта на простатата бива притиснат
                                (вж. графика нр. 1), намалявайки струята на уринния лъч от пикочния мехур. Понякога, при
                                пълно притискане, това може да доведе до невъзможност в изпразването на пикочния мехур с
                                остра задръжка на урината (уринна ретенция). Ретенционния синдром не винаги зависи от
                                големината на аденома. Провокиращи моменти и фактори за това могат да бъдат простудата,
                                полови и алкохолни ексцесии, залежаване, остър простатит (възпаление на простатата) и
                                др.<br/>
                                Симптомите на доброкачествения простатен синдром включват:
                                - неудържими позиви за уриниране с или без болка или с или без нежелано изпускане на
                                урина
                                - тънка струя
                                - остра задръжка на урината (уринна ретенция) в по-напреднал стадий на заболяването
                                - чувство за непълно изпразване
                                - инициална хематурия (наличие на кръв в урината) като кървенето в лумена на мехура може
                                да предизвика тампонада (запушване, вследствие на кръвен съсирек)
                                - инфекция на пикочните пътища, най-често възпаление на простатата, изразяващо се с
                                болка в областта между тестисите и ануса, както и в долната част на корема (перинеална и
                                супрапубична болка)
                                - ректални тенезми и спазми в ануса
                                - висока температура понякога с втрисане
                                - импотенция
                                - пълен пикочен мехур с невъзможност за спонтанно евакуиране на съдьржимото му (хронична
                                ретенция) с обструкция на уретерите и съпътстваща хидронефроза (задържане на урина в
                                бъбреците), което може да доведе до бъбречна недостатъчност
                                - хемоспермия (наличие на кръв в еякулата)<br/>
                                <h2>Урологични изследвания, извършващи се при уточняване на простатна хиперплазия:</h2>

                                За да се постави диагнозата, обикновено е необходимо да се извърши пълен урологичен
                                преглед, който включва ректално туширане на простата за определяне на състоянието й
                                (аденом, тумор, възпаление), семенните мехурчета и пикочния мехур. Провежда се анализ на
                                оплакванията чрез попълване на въпросник, наречен международен простатен симптоматичен
                                индекс (IPSS-Score), кръвен тест на простатния специфичен антиген (ПСА), евентуално ЯМР
                                на простата, за да се изключи простатен карцином. Нужно е също така изследване на
                                урината и при наличие на хематурия ендоскопско изследване с уретроцистоскопия и
                                рентгенова диагностика с обзорна и екскреторна урография, компютърна томография или
                                ядрено-магнитен резонанс. Диагноастиката се завършва с урофлоуметрия и ехографско
                                изследване.<br/>
                                <h2>Лечение на доброкачествената простатна хиперплазия </h2>
                                Медикаментозно лечение
                                Използват се различни препарати като алфа блокери (тамсулозин, теразоcин, силодозин)
                                които отпускат изхода на пикочния мехур и простатата, като така подобряват силата на
                                уринния лъч; 5-алфа-редуктазни инхибитори (финастерид и дутастерид), които
                                предотвратяват превръщането на тестостерона в дихидротестостерон (ДХТ) и тяхната
                                комбинация (алфузозин и финастерид) и (тамсулозин и дутастерид). Един от най-новите
                                медикаменти е Тадалафил 5 мг, който спада към така наречените инхибитори на
                                фосфодиестераза тип 5 (ФДЕ5) и се използва и при еректилна дусфункция, и при простатна
                                хиперплазия. Освен това антихолинергетици или бета 3-адренорецепторни агонисти, които
                                повлияват и облекчават симптомите при свръхактивен пикочен мехур.<br/>
                                <h2>Оперативно лечение при доброкачествената простатна хиперплазия:</h2>
                                Оперативното лечение на уголемена простата представлява отстраняване на жлезата по
                                оперативен път. Класическият метод е трансуреталната резекция (ТУРП). Възможно е
                                безкръвно отстраняване с лазер или енуклеация на простата. Един от по-новите методи е
                                намаляването на простата с помощта на pоботна система AquaBeam (Procept BioRobotics,
                                Redwood Shores, CA, USA). Най-честите странични ефекти на тези терапии включват
                                инконтиненция, постоперативни стеснявания на уретрата, склероза на шийката на пикочния
                                мехур, значителна кръвозагуба, уросепсис, тампонада на пикочния мехур, еректилна
                                дисфункция, ретроградна еякулация, ТУР-синдром, перфорация на простатната капсула.<br/>
                                <h2>Какво представлява новият метод трансуретрална аблация на простата с водна пара по
                                    метода Rezūm (Резум):</h2>
                                Системата Rezūm ™ използва принципа на конвективна енергия с кондензация на водната пара
                                (вж. фигура 2 и 3).<br/>
                                <CardMedia
                                    component='img'
                                    image={fig2}
                                />
                                <CardMedia
                                    component='img'
                                    image={fig3}
                                />
                                <br/>
                                При преобразуването на водата от течно в газообразно състояние се отделя голямо
                                количество топлинна енергия, което води до денатурация на клетъчните мембрани и апоптоза
                                на клетките. Освен това се наблюдава и денервация на алфа-адренергичните нерви в зоната
                                на лечение. Енергията се насочва и контролира директно чрез помощта на игла, която се
                                инжектира визуално на около 1 сантиметьр дьлбочина, в преходната област на простатата с
                                особено внимание към обструктивната тъкан под шийката на пикочния мехур (погледнете
                                фигура 4 ).<br/>
                                <CardMedia
                                    component='img'
                                    image={fig4}
                                /><br/>
                                Контролираното отдаване на енергия позволява да се проведе последователно и предвидимо
                                лечение (вж. фигура 5 ).<br/>
                                <CardMedia
                                    component='img'
                                    image={fig5}
                                /><br/>
                                <h2>Фигура 5. Следоперативни промени, в централната/преходната част на простатна жлеза
                                    преди, по време и след терапия с Резум. </h2>
                                Всяка инжекция в простатната тъкан продължава девет секунди, в които се впръсква по 0,42
                                ml загрята стерилна водна пара до 103 градуса, която бързо и равномерно в се разпределя
                                в междуклетъчното пространство на простатата. Простатната тъкан се усвоява от тялото по
                                време на естествения процес на оздравяване в първите 3 до 6 месеца след терапията.
                                Обикновено пациентите получават веднага след лечението катетър, който се отстранява след
                                около два дни до 6 седмици, според индивидуалната анатомия на пациента.<br/>
                                Лечението може да се извърши в обща анестезия, седация или локална анестезия и
                                обикновено трае около 10 минути.
                                <br/>
                                Индикацията за Резум на простатата по принцип се дава при всички пациенти със
                                симптоматична увеличена простата. Процедурата е подходяща за размер на простатната жлеза
                                от 30 до 80 мл.
                                При пациенти, подлежащи на антикоагулантна терапия, този вид операция може да бъде
                                особено щадяща при минимален риск от кървене. Според актуалните изследвания не е
                                необходимо задължително терапията с антикоагуланти да се спира.
                                <br/>
                                Единствените противопоказания за използването на системата Резум са наличието изкуствен
                                имплант при инконтиненция на пикочния мехур или еректилна дисфункция, стесняване на
                                уретрата, или склероза на шийката на пикочния мехур.
                                <br/>
                                Според актуалните изследвания минимално инвазивното лечение с Резум осигурява значително
                                и трайно облекчаване на симптомите, както и подобряване на уринния лъч до 5 години, с
                                ниска степен на необходимост от повторно хирургично лечение (4,4%) до 5 години. Не се
                                наблюдава негативно влияние върху сексуалната функция. Нуждата от нов прием на
                                урологични медикаменти след операцията за 5 години е около 11% (Източник Final 5-Year
                                Outcomes of the Multicenter Randomized Sham-Controlled Trial of a Water Vapor Thermal
                                Therapy for Treatment of Moderate to Severe Lower Urinary Tract Symptoms Secondary to
                                Benign Prostatic Hyperplasia, McVary KT, J Urol. 2021 Sep).
                                <br/>
                                Процедурата се извършва амбулаторно, изключително щадяща за пациента и с висока
                                успеваемост.
                                <br/>
                                <h2>Заключение</h2>
                                Резум (Rezūm) е минимално инвазивен метод, с който може успешно да се оперират пациенти
                                с доброкачествената простатна хиперплазия. Той комбинира предимствата на минимално
                                инвазивната хирургия и позволява запазването на еректилната и еякулаторната функция
                                следоперативно. Подходящ е при възрастни пациенти, подлежащи на уретрална катетеризация
                                и при млади пациенти, които желаят запазване на сексуалната функция и фертилитета.
                                Терапията показва стабилни следоперативни резултати до 5 години по сведения от
                                актуалните научни проучвания. Едно от най-големите предимства на лечението е
                                възможността за амбулаторно, безстресово провеждане и възстановяване в рамките на
                                часове.
                            </p>
                        </div>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">

                        <div className="nine columns main-col">
                            <h2>{t('rezum.block_1')}</h2>
                            <hr/>
                            <p className="white">
                                {t('rezum.block_2')}
                                <hr/>
                                <h2>{t('rezum.block_3')}</h2><br/>
                                {t('rezum.block_4')}
                                <hr/>
                                <h2>{t('rezum.block_5')}</h2><br/>
                                {t('rezum.block_6')}<br/>
                                {t('rezum.block_7')}<br/>
                                {t('rezum.block_8')}<br/>
                                {t('rezum.block_9')}<br/>
                                {t('rezum.block_10')}
                                <hr/>
                                <h2>{t('rezum.block_11')}</h2><br/>
                                {t('rezum.block_12')}
                                <hr/>
                                <h2>{t('rezum.block_13')}</h2><br/>
                                <ol>
                                    <li>{t('rezum.list.1')}</li>
                                    <li>{t('rezum.list.2')}</li>
                                    <li>{t('rezum.list.3')}</li>
                                </ol>
                                <ReactPlayer
                                    url='https://cdn.mannheim-urology.com/videos/rezum-video-1.mp4'
                                    controls={true}/>
                            </p>
                        </div>
                    </div>
                </section>
            )
    }
}

export default Rezum



// WEBPACK FOOTER //
// ./src/Components/Rezum.js